module.exports = __webpack_public_path__ + "img/status_map_generic_controls_to_framework_controls.b95c29b1.gif";